import {createFileRoute, redirect} from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/_company/_legacy/company-edit/$companyId")({
  params: {
    parse: raw => ({companyId: +raw.companyId}),
    stringify: params => ({companyId: params.companyId?.toString()}),
  },
  beforeLoad: ({params, search}) => {
    throw redirect({to: "/company/$companyId/edit", params: {companyId: params.companyId}, search, replace: true});
  },
});
